export const CUSTOMER_STATUS = {
  NEUKUNDE: 'Neukunde',
  BESTANDSKUNDE: 'Bestandskunde'
}
